import dayjs from 'dayjs';

// A due date is owed for the whole day, so a date is only "past" once its day has ended.
// @ai-generated 2026-09-09T12:15:31+00:00 by niklas.eicker@tngtech.com using Claude Opus 5 (1M context)
export const isDateBeforeToday = (data: unknown): boolean => {
    if (typeof data !== 'string' && !(data instanceof Date)) {
        return false;
    }

    return dayjs(data).endOf('day').isBefore();
};
